// extracted by mini-css-extract-plugin
module.exports = {"meal":"MealItem_meal__1S5eu","description":"MealItem_description__U1eyM","price":"MealItem_price__2GWXt"};